import { Linkify } from "@/components/Linkify";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ClipboardList, Printer } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Instructions() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/public/instructions/${token}`).then(({ data }) => setData(data)).catch(() => setErr(true));
  }, [token]);

  if (err) return <div className="min-h-screen flex items-center justify-center text-muted-foreground p-6" data-testid="instructions-error">These instructions couldn't be found.</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;

  const logo = data.business?.logo_url ? (data.business.logo_url.startsWith("/") ? API + data.business.logo_url : data.business.logo_url) : null;

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="instructions-page">
      <style>{`@media print { .no-print { display: none !important; } body { background: #fff; } }`}</style>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <div className="flex items-center justify-between gap-3 mb-8">
          <div className="flex items-center gap-3">
            {logo ? <img src={logo} alt={data.business?.name} className="h-12 w-12 rounded-xl object-cover border border-border" /> : <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center"><ClipboardList className="h-6 w-6 text-primary" /></div>}
            <div>
              <div className="font-heading font-bold text-lg">{data.business?.name}</div>
              {data.business?.phone && <div className="text-xs text-muted-foreground">{data.business.phone}</div>}
            </div>
          </div>
          <button onClick={() => window.print()} className="no-print inline-flex items-center gap-1.5 text-sm rounded-lg border border-border px-3 py-2 hover:bg-muted/50" data-testid="instructions-print"><Printer className="h-4 w-4" />Print</button>
        </div>

        <div className="rounded-2xl border border-border bg-card p-6 sm:p-8 shadow-sm">
          <div className="font-mono-label text-[11px] uppercase tracking-widest text-primary mb-2">{data.service_name || "Treatment"}</div>
          <h1 className="font-heading font-extrabold text-2xl sm:text-3xl tracking-tight">{data.title}</h1>
          {data.client_name && <p className="text-muted-foreground mt-1">Prepared for {data.client_name}</p>}
          <div className="mt-6 whitespace-pre-wrap leading-relaxed text-[15px]" data-testid="instructions-body"><Linkify text={data.instructions} /></div>
        </div>

        <p className="text-center text-xs text-muted-foreground mt-6">If anything here is unclear or you have concerns, please contact {data.business?.name || "the clinic"}.</p>
      </div>
    </div>
  );
}
